import styled from 'styled-components';

// Container per icon image
export const IconImageContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;
`;

// Immagine dell'icona
export const IconImage = styled.img`
    max-width: 100%;
    max-height: 100%;
`;

// Placeholder per l'icona
export const IconPlaceholder = styled.span`
    font-size: 11px;
    color: ${(props) => props.theme.app.primary};
`;

// Preview del bottone
export const ButtonPreview = styled.div<{
    backgroundColor: string;
    textColor: string;
    borderSize: string;
    borderColor: string;
    borderRadius: string;
}>`
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 8px 16px;
    background-color: ${(props) => props.backgroundColor};
    color: ${(props) => props.textColor};
    border: ${(props) => props.borderSize} solid ${(props) => props.borderColor};
    border-radius: ${(props) => props.borderRadius};
`;

// Icona nel preview del bottone
export const PreviewIcon = styled.img`
    width: 16px;
    height: 16px;
`;
